import { ref } from 'vue'

export const FOCUSABLE = '[tabindex],a,button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,audio,video,iframe,area,[contenteditable],[draggable]'

export const pageTitle = ref('')

export function htmlContainsText(html: string) {
  const el = document.createElement('span')
  el.innerHTML = html ?? ''
  return (el.textContent ?? '').trim().length > 0
}

export function stripHtml(html: string): string {
  const el = document.createElement('span')
  el.innerHTML = html ?? ''
  return el.textContent ?? ''
}

export function stripMarkdown(text: string): string {
  return text
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // [text](url) → text
    .replace(/\*\*([^*]+)\*\*/g, '$1') // **bold** → bold
    .replace(/\*([^*]+)\*/g, '$1') // *italic* → italic
    .replace(/`([^`]+)`/g, '$1') // `code` → code
    .replace(/^#{1,6}\s+/gm, '') // # headers
    .replace(/\s+/g, ' ')
    .trim()
}

export function setTitle(title: string) {
  pageTitle.value = `${title} – Aunivers`
  document.title = pageTitle.value
}

export function isElement(node: Node): node is Element {
  return node.nodeType === Node.ELEMENT_NODE
}
